<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "emptyLayout"
}
</script>

<style scoped>

</style>
